// Estructura de la plataforma dividida por EQUIPOS de una operación política.
// Fuente única de verdad: la usan el menú lateral (Sidebar) y el tablero /equipos,
// así nunca se desincronizan. Cada equipo agrupa las herramientas (secciones) de un
// área, con una descripción de qué hace ese equipo y qué resuelve cada herramienta.

import {
  FaHome, FaIdBadge, FaTrophy, FaChessKnight, FaBullseye, FaCalendarAlt, FaRegLightbulb, FaFireAlt, FaShieldAlt,
  FaCommentDots, FaNewspaper, FaHeartbeat, FaBullhorn,
  FaShareAlt, FaUserSecret, FaUserPlus, FaRobot, FaBolt, FaHashtag,
  FaMapMarkedAlt, FaAddressBook,
  FaGavel, FaLandmark,
  FaProjectDiagram, FaUserFriends, FaSearch, FaLayerGroup, FaBrain,
  FaVoteYea, FaChartLine, FaChartPie,
  FaCog, FaUsersCog,
} from 'react-icons/fa';

export const TEAMS = [
  {
    id: 'conduccion',
    name: 'Conducción',
    tagline: 'War Room',
    role: 'La mesa chica del candidato: estrategia, agenda y las decisiones que ordenan toda la campaña.',
    icon: FaChessKnight,
    color: '#00b4d8',
    tools: [
      { to: '/copiloto', label: 'Mi Copiloto', icon: FaRobot, badge: 'IA', desc: 'Consultá y resolvé con IA: borradores listos para usar' },
      { to: '/perfil', label: 'Perfil Político', icon: FaIdBadge, desc: 'El dossier del candidato de un vistazo' },
      { to: '/camino-2027', label: 'Camino a 2027', icon: FaTrophy, desc: 'La hoja de ruta hacia la elección' },
      { to: '/estrategia', label: 'Sala de Estrategia', icon: FaChessKnight, desc: 'Plan del día, narrativa rival y preparador' },
      { to: '/objectives', label: 'Objetivos', icon: FaBullseye, desc: 'Las metas de campaña y su avance' },
      { to: '/planning', label: 'Planificación', icon: FaCalendarAlt, desc: 'Agenda y calendario de actividades' },
      { to: '/opportunities', label: 'Oportunidades y Riesgos', icon: FaRegLightbulb, desc: 'Qué aprovechar y qué cuidar' },
      { to: '/urgencia', label: 'Sala de Crisis', icon: FaFireAlt, badge: 'IA', desc: 'Arma un kit de crisis con IA en minutos' },
      { to: '/crisis', label: 'Modo Crisis', icon: FaShieldAlt, desc: 'Qué vigila el sistema solo y qué encontró' },
    ],
  },
  {
    id: 'comunicacion',
    name: 'Comunicación y Prensa',
    tagline: 'Vocería',
    role: 'Qué se dice y cómo: mensajes, materiales listos para usar y la relación con los medios.',
    icon: FaBullhorn,
    color: '#f77f00',
    tools: [
      { to: '/messaging', label: 'Mensajería y Materiales', icon: FaCommentDots, desc: 'Copilot de contenido y biblioteca de piezas' },
      { to: '/prensa', label: 'Motor de Prensa', icon: FaNewspaper, desc: 'Contactos de prensa y gacetillas' },
      { to: '/media', label: 'Medios', icon: FaNewspaper, desc: 'Qué publican los diarios y portales' },
      { to: '/reputacion', label: 'Reputación', icon: FaHeartbeat, desc: 'Cómo está la imagen pública día a día' },
    ],
  },
  {
    id: 'digital',
    name: 'Digital y Redes',
    tagline: 'Community',
    role: 'Presencia y conversación en redes, las cuentas gestionadas y lo que la IA hace en vivo.',
    icon: FaHashtag,
    color: '#e63946',
    tools: [
      { to: '/social', label: 'Redes Sociales', icon: FaShareAlt, desc: 'Actividad, alcance y clima en redes' },
      { to: '/ai-live', label: 'IA en vivo', icon: FaBolt, badge: 'LIVE', desc: 'Qué está haciendo la IA ahora mismo' },
      { to: '/perfiles-digitales', label: 'Perfiles Digitales', icon: FaUserSecret, desc: 'Cuentas gestionadas para presencia y escucha' },
      { to: '/creador-perfiles', label: 'Creador de perfiles', icon: FaUserPlus, desc: 'Alta de nuevos perfiles digitales' },
      { to: '/automatizacion-perfiles-ia', label: 'Perfiles IA · Jobs', icon: FaRobot, desc: 'Automatizaciones de los perfiles' },
    ],
  },
  {
    id: 'territorio',
    name: 'Territorio y Vecinos',
    tagline: 'La calle',
    role: 'El contacto cara a cara: recorridas por barrio y gestión de los reclamos de los vecinos.',
    icon: FaMapMarkedAlt,
    color: '#38b000',
    tools: [
      { to: '/territorio', label: 'Gestión Territorial', icon: FaMapMarkedAlt, desc: 'El mapa de barrios y las recorridas' },
      { to: '/vecinos', label: 'Vecinos (CRM)', icon: FaAddressBook, desc: 'Base de vecinos y seguimiento de reclamos' },
    ],
  },
  {
    id: 'institucional',
    name: 'Labor Institucional',
    tagline: 'El Concejo',
    role: 'La actividad en el Concejo Deliberante: tu trabajo legislativo y el seguimiento del cuerpo.',
    icon: FaLandmark,
    color: '#fee440',
    tools: [
      { to: '/labor-hcd', label: 'Mi labor en el HCD', icon: FaGavel, desc: 'Tus proyectos, expedientes y actividad' },
      { to: '/monitoring/hcd', label: 'HCD San Nicolás', icon: FaLandmark, badge: 'LIVE', desc: 'Seguimiento en vivo del Concejo' },
    ],
  },
  {
    id: 'inteligencia',
    name: 'Inteligencia',
    tagline: 'Saber más',
    role: 'Saber más que el resto: dossiers de rivales, competencia, licitaciones e investigación.',
    icon: FaUserSecret,
    color: '#00f5d4',
    tools: [
      { to: '/investigations', label: 'Dossiers · Política SN', icon: FaProjectDiagram, desc: 'Investigaciones sobre personas y temas' },
      { to: '/competitors', label: 'Competencia 360°', icon: FaUserFriends, desc: 'Qué hacen y comunican los rivales' },
      { to: '/licitaciones', label: 'Radar de Licitaciones', icon: FaSearch, desc: 'Licitaciones del municipio bajo la lupa' },
      { to: '/research', label: 'Investigación', icon: FaBrain, desc: 'Research profundo de cualquier tema' },
      { to: '/analysis', label: 'Análisis Lab', icon: FaLayerGroup, desc: 'Tableros de análisis a medida' },
    ],
  },
  {
    id: 'datos',
    name: 'Datos y Elecciones',
    tagline: 'Los números',
    role: 'Los números que ordenan la campaña: mapa electoral, encuestas y métricas de rendimiento.',
    icon: FaChartPie,
    color: '#4cc9f0',
    tools: [
      { to: '/electoral', label: 'Inteligencia Electoral', icon: FaVoteYea, desc: 'Resultados, circuitos y encuestas' },
      { to: '/kpis', label: 'KPIs', icon: FaChartLine, desc: 'Indicadores clave de la campaña' },
    ],
  },
  {
    id: 'administracion',
    name: 'Administración',
    tagline: 'Sistema',
    role: 'La cocina de la plataforma: usuarios del equipo, permisos y ajustes.',
    icon: FaUsersCog,
    color: '#adb5bd',
    tools: [
      { to: '/settings', label: 'Configuración', icon: FaCog, desc: 'Usuarios, roles y ajustes' },
    ],
  },
];

// Secciones sensibles: solo visibles para ciertos roles. El resto se ve para todos.
export const RESTRICTED = {
  '/settings': ['admin'],
  '/perfiles-digitales': ['admin', 'estratega'],
  '/creador-perfiles': ['admin', 'estratega'],
  '/automatizacion-perfiles-ia': ['admin', 'estratega'],
};

export function canSee(to, role) {
  const allowed = RESTRICTED[to];
  return !allowed || allowed.includes(role);
}

// Ítem fijo arriba del menú: acceso al tablero de equipos.
export const TEAMS_HUB = { to: '/equipos', label: 'Equipos', icon: FaLayerGroup };

// Ítem fijo: la home (Centro de mando).
export const HOME = { to: '/', label: 'Inicio', icon: FaHome, exact: true };

// Ítem fijo debajo de Equipos: el agente atraviesa todas las áreas, así que no
// pertenece a un equipo en particular — vive arriba, junto a Inicio y Equipos.
export const AGENT_NAV = {
  to: '/agente',
  label: 'Agente de la plataforma',
  icon: FaBrain,
  badge: 'IA',
  desc: 'Preguntale por toda la operación: busca los datos y prepara los cambios',
};

// Secciones con lugar propio y permanente en el menú. No deben competir por un
// puesto en "Frecuentes" ni en "Seguí donde estabas": ya están siempre a mano,
// y repetirlas gasta un lugar que le sirve más a otra sección.
// La agenda tampoco cuelga de un equipo: cruza todas las áreas.
export const AGENDA_NAV = {
  to: '/agenda',
  label: 'Agenda',
  icon: FaCalendarAlt,
  desc: 'Tu día a día armado con los datos de la plataforma',
};

const FIXED_NAV_PATHS = [HOME.to, TEAMS_HUB.to, AGENT_NAV.to, AGENDA_NAV.to];
export const hasFixedNavSlot = (to) => FIXED_NAV_PATHS.includes(to);

/* ============================================================
   Lista plana de todas las secciones — la usan el buscador
   global (command palette), los "frecuentes" y los "recientes".
   Cada entrada sabe a qué equipo pertenece (nombre + color).
   ============================================================ */
export const ALL_SECTIONS = [
  // El agente no cuelga de ningún equipo (vive en la nav fija), pero tiene que
  // aparecer igual en el buscador, en frecuentes y en los accesos rápidos.
  { ...AGENT_NAV, team: 'Transversal', teamId: 'transversal', teamColor: '#00b4d8' },
  { ...AGENDA_NAV, team: 'Transversal', teamId: 'transversal', teamColor: '#00b4d8' },
  ...TEAMS.flatMap((team) =>
    team.tools.map((tool) => ({
      ...tool,
      team: team.name,
      teamId: team.id,
      teamColor: team.color,
    }))
  ),
];

// Búsqueda por texto sobre etiqueta, descripción y nombre del equipo.
export function searchSections(query, role) {
  const q = (query || '').trim().toLowerCase();
  return ALL_SECTIONS.filter((s) => {
    if (!canSee(s.to, role)) return false;
    if (!q) return true;
    return (
      s.label.toLowerCase().includes(q) ||
      (s.desc || '').toLowerCase().includes(q) ||
      s.team.toLowerCase().includes(q)
    );
  });
}

// Devuelve la sección (plana) que corresponde a una ruta, si existe.
export function sectionByPath(to) {
  return ALL_SECTIONS.find((s) => s.to === to) || null;
}

/* ============================================================
   Accesos rápidos del Centro de mando (home). Curados: lo que
   un candidato/equipo abre casi todos los días.
   ============================================================ */
export const QUICK_ACTIONS = [
  '/agente',
  '/copiloto',
  '/estrategia',
  '/reputacion',
  '/vecinos',
  '/territorio',
  '/prensa',
].map(sectionByPath).filter(Boolean);

/* ============================================================
   Frecuentes y recientes — se aprenden solos vía localStorage.
   No hay backend: es preferencia local del navegador del usuario.
   ============================================================ */
const VISITS_KEY = 'av_section_visits';
const PINS_KEY = 'av_section_pins';

function readJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}
function writeJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* almacenamiento no disponible: se ignora en silencio */
  }
}

// Registra una visita a una ruta (para calcular frecuentes/recientes).
export function recordVisit(to) {
  if (!sectionByPath(to)) return; // solo secciones reales del menú
  const visits = readJSON(VISITS_KEY, {});
  const entry = visits[to] || { count: 0, last: 0 };
  entry.count += 1;
  entry.last = Date.now();
  visits[to] = entry;
  writeJSON(VISITS_KEY, visits);
}

// Rutas fijadas manualmente con la ⭐.
export function getPins() {
  return readJSON(PINS_KEY, []);
}
export function isPinned(to) {
  return getPins().includes(to);
}
export function togglePin(to) {
  const pins = getPins();
  const next = pins.includes(to) ? pins.filter((p) => p !== to) : [...pins, to];
  writeJSON(PINS_KEY, next);
  return next;
}

// Frecuentes: primero los fijados, luego los más visitados. Máx `limit`.
export function getFrequentSections(role, limit = 6) {
  const visits = readJSON(VISITS_KEY, {});
  const pins = getPins();
  const seen = new Set();
  const out = [];

  const push = (to) => {
    if (seen.has(to) || hasFixedNavSlot(to)) return;
    const s = sectionByPath(to);
    if (!s || !canSee(to, role)) return;
    seen.add(to);
    out.push({ ...s, pinned: pins.includes(to) });
  };

  pins.forEach(push);
  Object.entries(visits)
    .sort((a, b) => b[1].count - a[1].count || b[1].last - a[1].last)
    .forEach(([to]) => push(to));

  return out.slice(0, limit);
}

// Recientes: por última visita, desc. Máx `limit`.
export function getRecentSections(role, limit = 5) {
  const visits = readJSON(VISITS_KEY, {});
  return Object.entries(visits)
    .sort((a, b) => b[1].last - a[1].last)
    .filter(([to]) => !hasFixedNavSlot(to))
    .map(([to]) => sectionByPath(to))
    .filter((s) => s && canSee(s.to, role))
    .slice(0, limit);
}
